var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGearFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#555;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.344,1.378a1.923,1.923,0,0,0-3.688,0l-.131.446A1.922,1.922,0,0,1,5.762,2.969l-.407-.223A1.923,1.923,0,0,0,2.747,5.354l.222.408A1.922,1.922,0,0,1,1.824,8.525l-.446.131a1.923,1.923,0,0,0,0,3.688l.446.131a1.922,1.922,0,0,1,1.145,2.763l-.223.407a1.923,1.923,0,0,0,2.608,2.608l.408-.222a1.921,1.921,0,0,1,2.763,1.144l.131.446a1.923,1.923,0,0,0,3.688,0l.131-.446a1.922,1.922,0,0,1,2.763-1.145l.407.223a1.923,1.923,0,0,0,2.608-2.608l-.222-.408a1.921,1.921,0,0,1,1.144-2.763l.446-.131a1.923,1.923,0,0,0,0-3.688l-.446-.131a1.921,1.921,0,0,1-1.144-2.763l.223-.407a1.923,1.923,0,0,0-2.608-2.608l-.408.222a1.922,1.922,0,0,1-2.763-1.144l-.131-.446ZM10.5,14.346A3.846,3.846,0,1,1,14.344,10.5,3.846,3.846,0,0,1,10.5,14.346Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearFill);
export default __webpack_public_path__ + "static/media/gear-fill.ba9c70a26685872eff2bc7dbabd3cafd.svg";
export { ForwardRef as ReactComponent };